import { EventGA4 } from "./eventGa4.model";

export class ReciptPaymentGa4 extends EventGA4 {

  reservationCode: string;
  passengerNameNumber: string;
  eventAction: string;
  errorCode: string;
  channel: string;
  station: string;
  kiosk_id: string;

  constructor(data){
    super(data);
    this.event = 'receipt_print';
    this.reservationCode = data?.reservationCode;
    this.passengerNameNumber = data?.passengerNameNumber;
    this.eventAction = data?.eventAction;
    this.errorCode = data?.errorCode;
    this.channel = data?.channel;
    this.station = data?.station;
    this.kiosk_id = data?.kiosk_id;
  }
}